import React from 'react';

/**
 * Sport icon components - simple stroke-based SVG icons for each sport
 * Icons are stroked with the secondary/alt color (white or team secondary color)
 */

export const FootballIcon = ({ color = '#ffffff', size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: '8px', flexShrink: 0 }}
  >
    <ellipse cx="12" cy="12" rx="9" ry="11" />
    <line x1="12" y1="1" x2="12" y2="23" />
    <line x1="5" y1="7" x2="19" y2="7" />
    <line x1="5" y1="12" x2="19" y2="12" />
    <line x1="5" y1="17" x2="19" y2="17" />
  </svg>
);

export const BasketballIcon = ({ color = '#ffffff', size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: '8px', flexShrink: 0 }}
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 2 C8 6, 8 18, 12 22" />
    <path d="M12 2 C16 6, 16 18, 12 22" />
    <line x1="2" y1="12" x2="22" y2="12" />
  </svg>
);

export const BaseballIcon = ({ color = '#ffffff', size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: '8px', flexShrink: 0 }}
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M8 4 L8 6 M8 8 L8 10 M8 14 L8 16 M8 18 L8 20" />
    <path d="M16 4 L16 6 M16 8 L16 10 M16 14 L16 16 M16 18 L16 20" />
  </svg>
);

export const SoccerIcon = ({ color = '#ffffff', size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: '8px', flexShrink: 0 }}
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 2 L14 8 L20 8 L15 12 L17 18 L12 14 L7 18 L9 12 L4 8 L10 8 Z" />
  </svg>
);

export const HockeyIcon = ({ color = '#ffffff', size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: '8px', flexShrink: 0 }}
  >
    <path d="M3 18 L9 12 L15 18" />
    <circle cx="18" cy="6" r="2" />
    <line x1="3" y1="18" x2="3" y2="21" />
    <line x1="15" y1="18" x2="15" y2="21" />
  </svg>
);

export const TennisIcon = ({ color = '#ffffff', size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: '8px', flexShrink: 0 }}
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12 Q12 2, 22 12 Q12 22, 2 12" />
  </svg>
);

export const GolfIcon = ({ color = '#ffffff', size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: '8px', flexShrink: 0 }}
  >
    <circle cx="12" cy="18" r="2" />
    <line x1="12" y1="2" x2="12" y2="16" />
    <path d="M12 2 L18 6 L12 10" />
  </svg>
);

export const HorseRacingIcon = ({ color = '#ffffff', size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: '8px', flexShrink: 0 }}
  >
    <path d="M4 18 L6 14 L8 10 L10 8 L12 7 L14 8 L16 10 L18 14 L20 18" />
    <circle cx="12" cy="6" r="2" />
    <line x1="4" y1="18" x2="4" y2="21" />
    <line x1="20" y1="18" x2="20" y2="21" />
  </svg>
);
